import { gql } from '@apollo/client'

export type { Company, CompanyVariables } from './types/index.graphql'

export const COMPANY = gql`
  query Company($id: Int!) {
    company(id: $id) {
      id
      name
      logo
    }
  }
`
